import axios from "axios";
import axiosInstance from './index';

export const getCustomerData = async (search: any) => {
  let page = 1;
  let limit = 20;
  try {
    const { data } = await axiosInstance.get(
      `/customer?page=${page}&limit=${limit}&search=${search}`
    );
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getCustomerDataById = async (id: any) => {
  try {
    const { data } = await axiosInstance.get(`/customer/${id}`);
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const createCustomer = async (data: any) => {
  try {
    const response = await axiosInstance.post(
      `/customer/create`,
      data
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const updateCustomer = async (data: any,id:string) => {
  try {
    const response = await axiosInstance.put(`/customer/${id}`, data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getCities = async () => {
  try {
    const response = await axiosInstance.get(`/enquiry/ports`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getCruises = async () => {
  try {
    const response = await axiosInstance.get(`/enquiry/ships`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getOptions = async () => {
  try {
    const response = await axiosInstance.get(
      `/enquiry/common-details`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }

}
export const getDestinationPorts = async (name:string) => {
  try {
    const response = await axiosInstance.get(
      `/enquiry/destination-ports?departurePort=${name}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }

}
export const getUpcomingItinerary = async () => {
  try {
    const response = await axiosInstance.get(
      `itinerary/upcoming`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }


};
export const checkExistCustomerEnquiry = async (id:string) => {
  try {
    const response = await axiosInstance.get(
      `enquiry/customer/${id}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getQuotationById= async (id:string) => {
  try {
    const response = await axiosInstance.get(
      `quotation/customer/${id}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};

export const getEmailLogs = async (searchText: string, currentPage: number) => {
  try {
    const params = new URLSearchParams({
      page: `${currentPage}`, limit: '15',
      ...(!!searchText && { emailTo: searchText }),
      key: 'mai_2024'
    });
    const response = await axiosInstance.get('/public/email-logs', { params });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error;
    } else {
      console.error("Unknown error occurred:", error);
    }
  }
};